import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import { mapTaxRuleListItem } from './mapTaxRuleListItem';
import type { TaxRuleListRow } from './types';

function extractTaxRulesListArray(data: unknown): unknown[] {
  if (Array.isArray(data)) return data;
  const o = data as Record<string, unknown> | null;
  if (!o) return [];
  const nested = o.taxRules ?? o.items ?? o.data;
  return Array.isArray(nested) ? nested : [];
}

export async function getTaxRules(): Promise<TaxRuleListRow[]> {
  const localApi = await getLocalApi();
  const url = (apiConfig as Record<string, string>).tax_rules_get_all;
  if (!url) {
    throw new Error('Tax rules API is not configured');
  }
  return localApi.fetchList(
    url,
    mapTaxRuleListItem,
    'Unable to fetch tax rules',
    extractTaxRulesListArray
  );
}

export async function fetchTaxRulesListRecords(): Promise<Record<string, unknown>[]> {
  const localApi = await getLocalApi();
  const url = (apiConfig as Record<string, string>).tax_rules_get_all;
  if (!url) {
    throw new Error('Tax rules API is not configured');
  }
  return localApi.fetchList(
    url,
    (item: unknown) => item as Record<string, unknown>,
    'Unable to fetch tax rules list',
    extractTaxRulesListArray
  );
}